import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Discovervaping() {
  return (
    <section className="discover_vaping p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Solution Discovery</h2>
            <p>
              Tekrevol designed a solution that could act as a pinnacle of
              change in the market. The app was supported by features and
              functionalities that would ensure a healthier and sustainable
              community. Our team analyzed the project from a technical
              standpoint.
            </p>
            <p>
              After comprehensive ideation and iteration, we developed a
              strategic roadmap to create the anti-vaping app.
            </p>
            <p>
              Here’s what our team streamlined, before initiation of the
              development phase:
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="vaping_solution">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/solution_discovery.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={327}
                height={650}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="solution_dis_box">
              <div className="num">01</div>
              <p>
                The compelling design, layout, and experience that the Stop
                vaping app would have.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="solution_dis_box">
              <div className="num">02</div>
              <p>
                Integration of specific functionality and features that catered
                to the young audience.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="solution_dis_box">
              <div className="num">03</div>
              <p>
                Empowered communication aspects within the app to ensure maximum
                connectivity and interaction of users.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mt-4">
            <p>
              We imagined the “Stop vaping App” as a modern solution based on
              advanced technologies that compelled users to minimize their
              unhealthy habits, conveniently and in an engaging way.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Discovervaping;
